import React, { useEffect } from 'react'
import HeroSection from '../sections/HeroSection'
import AboutSection from '../sections/AboutSection'
import StatsSection from '../sections/StatsSection'
import SkillSection from '../sections/SkillSection'
import ResumeSection from '../sections/ResumeSection'
import PortafolioSection from '../sections/PortafolioSection'
import ServicesSection from '../sections/ServicesSection'
// import TestimonialsSection from '../sections/TestimonialsSection'
import ContactSection from '../sections/ContactSection'
import { useParams, useNavigate } from 'react-router-dom';

const Main = () => {
  const { idSection } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const section = document.getElementById(idSection || "hero");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }, [idSection]);

  useEffect(() => {
    let timer; // Variable para almacenar el temporizador
  
    const handleScroll = () => {      
      if (timer) {
        clearTimeout(timer);
      }
  
      timer = setTimeout(() => {
        const sections = document.querySelectorAll('section[id]');
        let currentSection = 'home';
  
        sections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          if (rect.top <= window.innerHeight * 0.2 && rect.bottom > 0) {
            currentSection = section.id;
          }
        });
  
        navigate(`/${currentSection}`, { replace: true });
      }, 50);
    };
  
    window.addEventListener('scroll', handleScroll);
  
    return () => {
      clearTimeout(timer); // Limpiar el temporizador al desmontar el componente
      window.removeEventListener('scroll', handleScroll);
    };
  }, [navigate]);

  return (
    <main className='main'>
      <HeroSection></HeroSection>
      <ServicesSection></ServicesSection>
      <PortafolioSection></PortafolioSection>
      <ResumeSection></ResumeSection>
      <SkillSection></SkillSection>
      {/* <TestimonialsSection></TestimonialsSection> */}
      <AboutSection></AboutSection>
      <StatsSection></StatsSection>
      <ContactSection></ContactSection>
    </main>
  )
}

export default Main